import {
    DELETEGATEWAYMAPPING_SUCCESS,
    DELETEGATEWAYMAPPING_FAILED,
    RESET_DELETEGATEWAYMAPPING,
    LOADING_DELETEGATEWAYMAPPING,
    NETWORK_ERROR_DELETEGATEWAYMAPPING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetDeleteGatewayMapping = () => {
    return { type: RESET_DELETEGATEWAYMAPPING };
};

const deleteGatewayMapping = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETEGATEWAYMAPPING });
    await adminServices
        .post("deleteGatewayMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(deleteGatewayMappingsuccess(res.data));
                    break;
                default:
                    dispatch(deleteGatewayMappingFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_DELETEGATEWAYMAPPING, payload: err });
        });
};
function deleteGatewayMappingsuccess(data) {
    return {
        type: DELETEGATEWAYMAPPING_SUCCESS,
        payload: data,
    };
}
function deleteGatewayMappingFailed(data) {
    return {
        type: DELETEGATEWAYMAPPING_FAILED,
        payload: data,
    };
}

export { resetDeleteGatewayMapping, deleteGatewayMapping };
